import type { Config } from "tailwindcss";
import defaultTheme from "tailwindcss/defaultTheme.js";
import plugin from "tailwindcss/plugin.js";
import { querySizeMappings } from "./schema/querySizeMappings.js";

export default {
	darkMode: "class",
	theme: {
		extend: {
			fontFamily: {
				sans: ["Montserrat", ...defaultTheme.fontFamily.sans],
				"druk-cond": ["'Druk Cond'", ...defaultTheme.fontFamily.sans],
				inter: ["Inter", ...defaultTheme.fontFamily.sans],
			},
			fontSize: {
				// https://v3.tailwindcss.com/docs/font-size
				"2xs": ["0.625rem", "0.5rem"],
				// These are Tailwind-native but with different line heights
				xs: ["0.75rem", "0.75"],
				sm: ["0.875rem", "1.5"],
				base: ["1rem", "1.5"],
				xl: ["1.5rem", "1.55"],
				// Tailwind ends with 9xl; for Huge headings
				"10xl": ["16rem", "0.90"],
			},
			// Prefix colors with shortcut of project name (example: fastest -> fstgreen)
			colors: {
				cmcprimary: "#00AFF0",
				cmcsecondary: "#183662",
				cmcnavy: "#173767",
				"cmcnavy-80": "#455F85",
				cmcbg: "#EFEFEF",
				cmctext: "#101010",
				cmcwarning: {
					100: "#FFF6F0",
					DEFAULT: "#F06400",
				},
				cmcsuccess: {
					100: "#D6F6E5",
					200: "#27AE60",
					DEFAULT: "#B4EECD",
				},
				cmcmidgray: "#AFAFAF",
				cmclightgray: "#EFEFEF",
			},
			lineHeight: {
				tighter: "1.125",
			},
			screens: Object.fromEntries(
				Object.entries(querySizeMappings).map(([breakpoint, size]) => [breakpoint, `${size}rem`]),
			),
		},
	},
	plugins: [
		plugin((tw) => {
			tw.matchUtilities(
				{
					"stroke-text": (value) => ({
						textShadow: `-1px -1px 0 ${value},
									-1px 1px 0 ${value},
									1px -1px 0 ${value},
									1px 1px 0 ${value}`,
					}),
				},
				{ values: tw.theme("colors") },
			);
		}),
	],
} satisfies Partial<Config>;
